import type { FC } from "react";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";

import { Typography } from "../Typography";

import styles from "./LegalDisclaimer.module.scss";

export type LegalDisclaimerProps = {
  title: string;
  description: string;
  linkLabel: string;
  href: string;
};

export const LegalDisclaimer: FC<LegalDisclaimerProps> = ({ title, description, href, linkLabel }) => {
  return (
    <div className={styles.legalDisclaimer} data-testid="legal-disclaimer">
      <div className={styles.textWrapper}>
        <Typography className={styles.title} variant="h3">
          {title}
        </Typography>
        <p className={styles.description}>{description}</p>
      </div>
      <Button className={styles.button} variant="text-muted" size="sm" href={href} iconAfter={LongArrowForwardIcon}>
        {linkLabel}
      </Button>
    </div>
  );
};
